import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  IAlertOptions,
  EnumAlertOptionFlexAlign,
  EnumAlertOptionTextAlign,
  EnumAlertOptionSize,
  AlertService,
  IAlertOptionsButton
} from '../../services/alert/alert.service';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    imports: [FormsModule, FaIconComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertComponent implements OnDestroy {
  alertOptions: IAlertOptions | null = null;

  EnumAlertOptionFlexAlign = EnumAlertOptionFlexAlign;
  EnumAlertOptionTextAlign = EnumAlertOptionTextAlign;
  EnumAlertOptionSize = EnumAlertOptionSize;

  dropdownValue: unknown = null;
  inputValue = '';
  checkboxValues: unknown[] = [];
  private alertSubscription: Subscription;

  constructor(private alertService: AlertService, private changeDetectorRef: ChangeDetectorRef) {
    this.alertSubscription = this.alertService.alertOptionsObservable.subscribe((alertOptions: IAlertOptions | null) => {
      this.alertOptions = alertOptions;

      this.dropdownValue = null;
      this.inputValue = alertOptions?.body?.input?.value ?? '';
      this.checkboxValues = (alertOptions?.body?.checkboxOptions || [])
        .filter(option => option.checked !== false)
        .map(option => option.value);
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.alertSubscription.unsubscribe();
  }

  get allCheckboxesSelected(): boolean {
    const options = this.alertOptions?.body?.checkboxOptions || [];
    return !!options.length && this.checkboxValues.length === options.length;
  }

  isCheckboxSelected(value: unknown): boolean {
    return this.checkboxValues.includes(value);
  }

  toggleCheckbox(value: unknown, checked: boolean): void {
    if (checked && !this.checkboxValues.includes(value)) {
      this.checkboxValues = [...this.checkboxValues, value];
    } else if (!checked) {
      this.checkboxValues = this.checkboxValues.filter(item => item !== value);
    }
  }

  toggleAllCheckboxes(): void {
    this.setAllCheckboxes(!this.allCheckboxesSelected);
  }

  setAllCheckboxes(checked: boolean): void {
    this.checkboxValues = checked
      ? (this.alertOptions?.body?.checkboxOptions || []).map(option => option.value)
      : [];
  }

  clickFooterBtn(button: IAlertOptionsButton): void {
    if (button.callback) {
      if (this.alertOptions?.body?.input) {
        button.callback(this.inputValue);
      } else if (this.alertOptions?.body?.checkboxOptions) {
        button.callback(this.checkboxValues);
      } else {
        button.callback(this.dropdownValue);
      }
    }
  }
}
